import { freeze as t } from "./utils/freeze.js";
var s = function() {
  function e(i, r) {
    this.inlineSize = i, this.blockSize = r, t(this);
  }
  return e;
}();
export {
  s as ResizeObserverSize
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/ResizeObserverSize.js
// module id = 1352
// module chunks = 67